const runningBuilds = [
  {
    name: "Built-in node",
    items: [
      {
        name: "Jenkins >> master",
        build: 1337
      }
    ]
  }
]

export default runningBuilds;
